import { createAsyncThunk } from '@reduxjs/toolkit'
import { http } from 'src/libs'
import { NOT_FOUND } from 'src/utils/errorCode'

export const ProfileAction = createAsyncThunk(
  'profileReducer',
  async (payload: any, thunkApi) => {
    try {
      const { response, error } = await http({
        method: 'GET',
        baseUrl: process.env.REACT_APP_API_BASE_URL,
        path: {
          url: 'GET_PROFILE',
        },
      })
      if (error) {
        return thunkApi.rejectWithValue(error)
      }
      const data = response?.data
      if (data?.errorCode === NOT_FOUND) {
        return thunkApi.rejectWithValue({ message: 'Not Found!' })
      }

      return thunkApi.fulfillWithValue(data)
    } catch (error) {
      return thunkApi.rejectWithValue(error)
    }
  }
)
